"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeadManagerContext = void 0;
var _interop_require_default = require("@swc/helpers/lib/_interop_require_default.js").default;
var _react = _interop_require_default(require("react"));
const HeadManagerContext = _react.default.createContext({});
exports.HeadManagerContext = HeadManagerContext;
if (process.env.NODE_ENV !== 'production') {
    HeadManagerContext.displayName = 'HeadManagerContext';
}

//# sourceMappingURL=head-manager-context.js.map